import chatIcon from '../../../assets/img/icon/chat.png'
import {  useEffect } from 'react'
import { Box } from '@mui/material'
import { MainContainer } from '@chatscope/chat-ui-kit-react'
import ChatList from './components/ChatList'
import ChatAction from './components/ChatAction'
import dropdown from '../../../assets/img/icon/down.png'
import { useDispatch, useSelector } from 'react-redux'
import Slide from '@mui/material/Slide';
import { useLocation } from 'react-router-dom'
import { onFloatingChat } from './redux/chatSlices'
import { RootState } from '../../../app/store'
import { getSettingPlatform } from '../masters/mastersReducers'
import LoaderBackdrop from '../../../components/LoaderBackdrop'
import { userCredentials } from '../../../utilities/config'
import { checkValidation } from '../../../utilities/userFeaturesValidation'


const ChatFloating = () => {
    const location = useLocation()
    function useQuery() {
        return new URLSearchParams(location.search);
    }
    
    let query = useQuery();
    let active_page = query.get('page')
    const dispatch = useDispatch()
    const { conversation_lists, open_floating } = useSelector((state:RootState) => state.chats);
    const { setting_platform, loading_setting_platform} = useSelector((state:RootState) => state.masters);

    const handleChange = () => {
        dispatch(onFloatingChat(!open_floating))
    };

    useEffect(() => {
        if (active_page !== 'error') {
            dispatch(getSettingPlatform());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active_page]);

    useEffect(() => {
        dispatch(onFloatingChat(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const Container = (
        <Box className='container-float-chat'>
            <Box px={2} pb={1} display='flex' justifyContent='space-between' >
                <h2>Chat</h2>
                <Box className='dropwdown' onClick={handleChange}>
                    <img src={dropdown} alt='down' />
                </Box>
            </Box>
            { loading_setting_platform ? 
            <LoaderBackdrop loading={true} /> : 
            <>
            {  setting_platform &&  setting_platform?.automation_fulfillment ? 
            <Box className='not-found-data' >
                <h1>Permission Denied!</h1>
                <p>Managed Vendor cant send chat message, if you want to operate in the platform Contact us.</p>
            </Box>
            :
            <Box className='chat-container-float'>
                <MainContainer responsive style={{borderRadius: 10}}>
                {conversation_lists.length > 0 ? 
                <>
                    <ChatList/>
                    <ChatAction width={40}/>
                </> 
                : 
                <>
                    <ChatAction width={50}/>
                </> }
                </MainContainer>
            </Box> 
            }
            </> }
        </Box>
    );

    return (
        <Box sx={{ display: checkValidation('REAMES803775') && userCredentials.company.isVerified ? 'block' : 'none'  }}>
            <Box 
                className="chat-floating-button"
                onClick={handleChange}
            >   { !open_floating && (
                <Box className='floating-card-chat'>
                    <Box component='img' src={chatIcon} alt='chat'/>
                    <h6>Chat</h6>
                </Box> 
                )}
            </Box>
            <Box >
                <Slide direction="up" in={open_floating} mountOnEnter unmountOnExit >
                    {Container}
                </Slide>
            </Box>
        </Box>
    )
}

export default ChatFloating